export interface SP111CameraSetting {
    PowerlineFreq: PowerLineFrequency;
    TvStandards: number;
    Brightness: number;
    ColorSaturation: number;
    Sharpness: number;
    Contrast: number;
    WhiteBalanceMode: WhiteBalanceMode;
    WhiteBalanceRedGain: number;
    WhiteBalanceBlueGain: number;
    DoorMode: DoorMode;
    DigitalImageStabilisation: DigitalImageStabilisation;
    DayToNight: number;
    NightToDay: number;
    DayNightSensitivity: number;
    D2nSensitivity: number;
    N2dSensitivity: number;
    SensorMode: ADCMode;
    DistortCorrect: LensDistortCorrect;
    FovAdjust: number;
    IrBlanceMode: SP111CameraSettingEnable;
    Enblur: SP111CameraSettingEnable;
    Deblur: number;
    DefogMode: SP111CameraSettingEnable;
    AntiFogIntensity: number;
    ReduceStuttering: number;
    ExposureMode: ExposureMode;
    ExposureTime: ExposureTime;
    ExposureGain: number;
    LedMode: number;
    NfLevel: number;
    Dnr2Level: number;
    FocusMode: FocusMode;
    AspectRatio: SP111CameraSettingEnable;
    ZoomLimit: ZoomLimit;
    SmartIrMode: SmartIrMode;
    NearViewIrLevel: number;
    MiddleViewIrLevel: number;
    FarViewIrLevel: number;
    DnSwitchRefocus: SP111CameraSettingEnable;
    SmokedDomeCover: number;
    WhiteLedLevel: number;
    MirrorCorridor: CorridorMode;
    ImageRotation: ImageRotation;
    IrCutFilter: DayNightMode;
    IricrDayHour: number;
    IricrDayMinute: number;
    IricrNightHour: number;
    IricrNightMinute: number;
    IricrGpinStatus: GpinStatus;
    IricrGpinNumber: number;
    PirDuration: number;
    PirSensitivity: number;
    ScheduleMode: ImageEnhancementMode;
    BacklightMode: number;
    BlcRegion: BLCRegion;
    BlcExclusive: BLCExclusive;
    BlcRegionArea: string;
    WdrMode: DynamicRangeMode;
    WdrStartHour: number;
    WdrStartMinute: number;
    WdrStopHour: number;
    WdrStopMinute: number;
    WdrLevel: number;
    WdrAflevel: number;
    HlcMode: HighLightCompensationMode;
    HlcLevel: number;
    DayEnhancementMode: EnhancementMode;
    NightEnhancementMode: EnhancementMode;
    MediaUrl: string;
    MediaWidth: number;
    MediaHeight: number;
    WhiteBalanceTaskdayList: string;
    ExposureTaskdayList: string;
    BlcWdrHlcTaskdayList: string;
    DnScheduleTaskday: string;
    LprNight: number;
    InlprNight: number;
    FishDisplayMode: number;
    FishCorrectMode: number;
    LprNightModeInEffect: number;
    IrSupplemen: number;
    IrisType: IrisType;
}

export enum PowerLineFrequency {
    SixtyHZ, // 60HZ
    FiftyHZ, // 50HZ
}

export enum WhiteBalanceMode {
    Auto,
    Manual,
    Incandescent,
    Warm,
    Natural,
    Flurescent,
    Schedule,
}

export enum DoorMode {
    Outdoor,
    Indoor,
}

export enum DigitalImageStabilisation {
    Enable = 1,
}

export enum ADCMode {
    Enable = 1,
}

export enum LensDistortCorrect {
    No,
    Yes,
}

export enum SP111CameraSettingEnable {
    Off,
    On,
}

export enum ExposureMode {
    Auto,
    Manual,
    Schedule,
}

export enum ExposureTime {
    OneFifth, // 1/5
    OneTenth, // 1/10
    OneTwentyFifthOrOneThirtieth, // 1/25 or 1/30
    OneFiftiethOrOneSixtieth, // 1/50 or 1/60
    OneHundredthOrOneOneHundredTwentieth, // 1/100 or 1/120
    OneTwoHundredFiftieth, // 1/250
    OneFiveHundredth, // 1/500
    OneSevenHundredFiftieth, // 1/750
    OneThousandth, // 1/1000
    OneTwoThousandth, // 1/2000
    OneFourThousandth, //  1/4000
    OneTenThousandth, //  1/10000
    OneHundredThousandth, //  1/100000
    One, // 1
}

export enum FocusMode {
    Auto,
    SemiAuto,
    Manual,
}

export enum ZoomLimit {
    MaxOpticalZoom,
    TwoMultiplyMaxOpticalZoom, // 2*max optical zoom
    FourMultiplyMaxOpticalZoom, // 4*max optical zoom
    EightMultiplyMaxOpticalZoom, // 8*max optical zoom
    SixTeenMultiplyMaxOpticalZoom, // 16*max optical zoom
}

export enum SmartIrMode {
    AutoMode,
    Customize,
}

export enum CorridorMode {
    OFF,
    Clockwise90Degrees, // Clockwise 90°
    Anticlockwise90Degrees, // Anticlockwise 90°
}

export enum ImageRotation {
    OFF,
    Rotating180Degrees, // Rotating 180°
    FlipHorizontal,
    FlipVertical,
}

export enum DayNightMode {
    AutoMode,
    NightMode,
    DayMode,
    Customize,
}

export enum GpinStatus {
    Close,
    Open,
}

export enum ImageEnhancementMode {
    SingleMode,
    DayNightMode,
    ScheduleMode,
}

export enum BLCRegion {
    Off,
    Customize,
    Center,
}

export enum BLCExclusive {
    Inclusive,
    Exclusive,
}

export enum DynamicRangeMode {
    Off,
    On,
    Customize,
}

export enum HighLightCompensationMode {
    Off,
    GeneralMode,
    EnhanceMode,
}

export enum EnhancementMode {
    BLC,
    WDR,
    HLC,
    Off,
}

export enum IrisType {
    None = -1,
    ManualIris,
    DcIris,
    PIris,
}
